import { SVGProps, Ref, forwardRef } from 'react';

export const DropsOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 0s5 4.739 5 10a5 5 0 0 1-4.045 4.907Q18 15.451 18 16a8 8 0 1 1-16 0c0-8.418 8-16 8-16s1.786 1.693 3.67 4.366l-.02.036C15.105 1.795 17 0 17 0m-4.23 6.244q-.13-.197-.26-.39A33 33 0 0 0 10 2.622a33 33 0 0 0-2.51 3.232C5.565 8.688 3.8 12.324 3.8 16a6.2 6.2 0 0 0 12.4 0q0-.537-.05-1.073A5 5 0 0 1 12 10c0-1.305.307-2.58.77-3.756M17 2.684a19 19 0 0 0-1.01 1.353C14.815 5.766 13.8 7.902 13.8 10a3.2 3.2 0 0 0 6.4 0c0-2.098-1.016-4.234-2.19-5.963A19 19 0 0 0 17 2.685"
            fill="currentColor"
        />
    </svg>
));
DropsOutlinedSize24Glyph.displayName = 'DropsOutlinedSize24Glyph';
